import styled from 'styled-components';
import { getColor, typeScale } from 'core/utils';

export const ExtraRating = styled.div`
	padding: ${typeScale(0.5)} 0;
	margin-right: ${typeScale(2)};
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const RatingLabel = styled.span`
	font-size: 12px;
	line-height: 1;
	letter-spacing: 0.24px;
	color: ${getColor("gray")};
	font-weight: 500;
	margin-left: ${typeScale(1)};
`;
